import { fechaLarga } from "@/lib/fechas";

const norm = (s) => (s || "").trim().toLowerCase();

// Asunto activo igual (título, fecha, hora y mascota/persona).
export const buscarDuplicado = (matters, p) => matters.find((m) =>
  !["PASADO", "HECHO"].includes(m.status) && norm(m.title) === norm(p.title) && (m.due_date || "") === (p.due_date || "") &&
  (m.due_time || "") === (p.due_time || "") && (m.pet_id || null) === (p.pet_id || null) &&
  (p.pet_id || (m.family_member_id || "fm-self") === (p.family_member_id || "fm-self")));

export const cuandoTxt = (a) => (a.due_date ? `${fechaLarga(a.due_date)}${a.due_time ? ` a las ${a.due_time}` : ""}` : "");

// Dónde verá el usuario el asunto recién guardado.
export const dondeTxt = (a) => {
  if (a.status === "REQUIERE TU ATENCIÓN") return "lo verás en Inicio › Requiere atención";
  if (a.status === "PRÓXIMAMENTE" || (a.tipo === "evento" && a.due_date)) return "lo verás en Próximos";
  return `lo verás en ${a.category} › Bajo control`;
};

export const mensajeGuardado = (a, pets, familyMembers) => {
  const quien = a.pet_id ? pets.find((p) => p.id === a.pet_id)?.name : familyMembers.find((f) => f.id === a.family_member_id)?.name;
  return ["Guardado", quien, cuandoTxt(a), dondeTxt(a)].filter(Boolean).join(" · ");
};
